module.exports = __webpack_public_path__ + "img/pieChart.cdb54e08.png";